<template>
    <div>
        <!-- License table -->
        <div class="card">
            <DataTable
                :value="allLicenses"
                :lazy="true"
                :paginator="true"
                :rows="10"
                ref="dt"
                data-key="id"
                :totalRecords="totalLicences"
                :loading="loading"
                @page="onPage($event)"
                responsiveLayout="scroll"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
            >
                <template #header>
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined mb-2" />
                        <div>
                            <span>
                                <label for="filter">Filter By</label>
                                <Dropdown class="mx-2" placeholder="Select License Status" :options="statuses" v-model="params.valid" optionLabel="label" optionValue="value" />
                            </span>
                        </div>
                    </div>
                </template>
                <template #empty>No licenses available.</template>
                <template #loading>Loading licenses. Please wait.</template>
                <Column field="id" header="LICENSE ID" style="max-width: 5rem">
                    <template #body="slotProps">
                        <span class="p-column-title">LICENSE ID</span>
                        {{ slotProps.data.id }}
                    </template>
                </Column>
                <Column field="company" header="COMPANY" style="max-width: 6rem">
                    <template #body="slotProps">
                        <span class="p-column-title">COMPANY</span>
                        {{ slotProps.data.company_name }}
                    </template>
                </Column>
                <Column field="product" header="PRODUCT" style="max-width: 6rem">
                    <template #body="slotProps">
                        <span class="p-column-title">PRODUCT</span>
                        {{ slotProps.data.product.code }}
                    </template>
                </Column>
                <Column field="license" header="LICENSE" style="max-width: 12rem">
                    <template #body="slotProps">
                        <span class="p-column-title">LICENSE</span>
                        {{ slotProps.data.product.description }}
                    </template>
                </Column>
                <Column field="startDate" header="START DATE" style="max-width: 8rem">
                    <template #body="slotProps">
                        <span class="p-column-title">START DATE</span>
                        {{ slotProps.data.start_date }}
                    </template>
                </Column>
                <Column field="endDate" header="END DATE" style="max-width: 8rem">
                    <template #body="slotProps">
                        <span class="p-column-title">END DATE</span>
                        {{ slotProps.data.end_date }}
                    </template>
                </Column>
                <Column field="actions" header="ACTIONS" style="min-width: 8rem">
                    <template #body="slotProps">
                        <span class="p-column-title">ACTIONS</span>
                        <Button icon="pi pi-eye" class="p-button-rounded p-button-info mr-2" @click="showDetails(slotProps.data.id)" v-tooltip="'View License Details'" />
                        <Button icon="pi pi-calendar-times" class="p-button-rounded p-button-success mr-2" @click="update(slotProps.data, 'renew')" v-tooltip="'Renew License'" />
                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="update(slotProps.data, 'suspend')" v-tooltip="'Suspend License'" aria-label="Suspend License" />
                    </template>
                </Column>
            </DataTable>
        </div>
        <!-- License Details Dialog -->
        <license-details v-if="detailsDialog" :license="licenseData" @hide-dialog="detailsDialog = false" />
        <!-- Renew or Suspend license dialog -->
        <update-license v-if="updateDialog" :mode="mode" :license="licenseData" @hide-dialog="reload" />
    </div>
</template>

<script setup>
import LicenseDetails from './LicenseDetails.vue';
import UpdateLicense from './UpdateLicenseDialog.vue';
import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { licenseStore } from '@/store/global-stores';

const { loading, statuses, params, allLicenses, totalLicences } = storeToRefs(licenseStore);

const licenseData = ref(null);

const detailsDialog = ref(false);
const updateDialog = ref(false);
const mode = ref(null);

const onlyValid = computed(() => {
    return params.value.valid;
});

// if only_valid filter is changed above then it will triggered this
watch(onlyValid, () => {
    licenseStore.getAllLicenses();
});

const onPage = async (event) => {
    params.value.page = event.page + 1;
    params.value.page_size = event.rows;
    await reload();
};

const showDetails = async (id) => {
    licenseData.value = await licenseStore.getLicenseDetailsById(id);
    detailsDialog.value = true;
};

const update = async (license, modeVal) => {
    mode.value = modeVal;
    licenseData.value = license;
    updateDialog.value = true;
};

// after contract renew or suspension, make a refresh to the license table
const reload = async () => {
    updateDialog.value = false;
    licenseStore.getAllLicenses();
};
</script>
